/* eslint-disable no-unused-vars */
import { convertArrayOfPrimitivesToDict } from "../utils/data";

export enum REGION {
    IE = "IE",
    UK = "UK",
}

export enum CLIENT_STATUSES {
    APPLICATION_SENT = "application-sent",
    ON_HOLD = "on-hold",
    PROCESSED_YOUR_RETURN= "processed-your-return",
    RETURN_OUTCOME = "return-outcome",
    APPLICATION_CLOSED = "application-closed",
}

export enum MAIN_STATUSES {
    ID_VERIFICATION = "id-verification",
}

export const ERROR_STATUSES = [
    "awaiting-questionnaire",
    "id-verification-fraud-check",
    "id-verification-failed",
    "id-verification-time-expired",
    "agent-link-creation-error",
] as const;

export const SECONDARY_STATUSES = [
    "agent-link-creation",
    "awaiting-code-submission",
    "ready-for-review",
    "submitted-to-hmrc",
    "awaiting-id-verification",
    ...ERROR_STATUSES,
] as const;

export const SECONDARY_STATUSES_DICT = convertArrayOfPrimitivesToDict(SECONDARY_STATUSES);

export const DETAILS_TYPE = ["account", "iban"] as const;

export const DETAILS_TYPE_DICT = convertArrayOfPrimitivesToDict(DETAILS_TYPE);
